/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { VisitViewModel } from './VisitViewModel'; 

export function getVisitOptions(visitId: string, onSuccess?: (result: VisitViewModel) => void) {
	return queryOptions({
		queryKey: ['visit', visitId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/visits/queries/getvisit/' + visitId;
			const resp = await axios.get<VisitViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(visitId)
	});
}